"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PrintMode = exports.PrintingSettings = void 0;
var PrintingSettings = (function () {
    function PrintingSettings() {
        this.mode = PrintMode.ServerPdf;
        this.closePrintDialogWithHtmlPreview = true;
    }
    PrintingSettings.prototype.copyFrom = function (obj) {
        this.mode = obj.mode;
        this.closePrintDialogWithHtmlPreview = obj.closePrintDialogWithHtmlPreview;
    };
    PrintingSettings.prototype.clone = function () {
        var result = new PrintingSettings();
        result.copyFrom(this);
        return result;
    };
    return PrintingSettings;
}());
exports.PrintingSettings = PrintingSettings;
var PrintMode;
(function (PrintMode) {
    PrintMode[PrintMode["ServerPdf"] = 0] = "ServerPdf";
    PrintMode[PrintMode["ClientHtml"] = 1] = "ClientHtml";
    PrintMode[PrintMode["ClientPdf"] = 2] = "ClientPdf";
})(PrintMode = exports.PrintMode || (exports.PrintMode = {}));
